<template>
  <div class="font" >
    <b-container fluid>
      <b-row>
        <b-col cols='7' class='mx-auto mt-4 ml-3 font-org-right-blue'>
          <h4><b-icon icon="files" class='mr-2'></b-icon>承認待ち応募者一覧</h4>
        </b-col>
        <b-col cols='5' class='mx-auto mt-4 px-4 text-right'>
          <AgencyList v-if="isAgency" @update="onUpdateAll" :currentOrg="1"></AgencyList>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols='8' class='mx-auto mt-4'>
          <b-row>
<!--             <b-col cols='4' class='pl-5'>
              <b-form-select v-model='selected' class='dirty' :options="emStatusOptions">
                <template #first>
                  <b-form-select-option :value="null" disabled>募集案件名</b-form-select-option>
                </template>
              </b-form-select>
            </b-col> -->
          </b-row>

          <b-row class='mt-3'>
            <b-col cols='12' class='px-0 text-center hoge mx-auto'>
              <b-row class="mb-5 pb-1">
                <b-col cols='4' class='text-left'>
                  <h4>全<span class="font-org-right-blue h45 px-1">{{ recruitList.length }}</span>件</h4>
                </b-col>
                <b-col cols='3' class='px-0'>
                  <b-row>
                    <b-col cols='11' class='px-0'>
                      <b-form-input v-model="searchWord" @change="onChangeSearch"  class='table-search-input' placeholder='キーワード検索'></b-form-input>
                    </b-col>
                    <b-col cols='1' class='px-0'>
                      <b-icon class='bg-org-blue p-2 table-search-icon' width='2.4rem' height='2.4rem' icon='search'></b-icon>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-table
                small
                :fields="fields"
                :items="recruitList"
                :bordered='true'
                head-variant='light'
                :per-page="perPage"
                :current-page="currentPage"
                responsive
                class='recruit-table px-0'
              >
                <template #cell(created_at)='data'>
                  <div class="mt-1 date-cell">
                    {{ tableDateFormat(data.item.created_at) }} <br> {{ tableTimeFormat(data.item.created_at)}}
                  </div>
                </template>
                <template #cell(job_id)='data'>
                  <router-link :to="'./jobOffer/' + data.item.job_id">
                    {{data.item.occupation}} / {{ (data.item.title) }}
                  </router-link> 
                </template>
                <template #cell(user_id)='data'>
                  <div style="width: 100%">
                    <router-link :to="'./jobSeeker/' + data.item.id">
                      <b-row>
                      <b-col cols='3' class='text-left pt-1 pl-3'>
                        <b-img :src="data.item.profile_image" rounded="circle" class="profile-image" alt=""></b-img>
                      </b-col>
                      <b-col cols='9' class='text-left'>
                        {{ data.item.last_name }} {{ data.item.sur_name }} {{ data.item.first_name }} <br>
                        <small class="text-dark">{{ data.item.age }}歳/{{ GENDER_LIST[data.item.gender] }} / {{data.item.current_address}}</small>
                      </b-col>
                      </b-row>
                    </router-link> 
                  </div>
                </template>

                <template #cell(state)='data'>
                  <div class="mt-2">
                    <span class="mx-1 text-red new" >新着</span>
                    <b-button pill @click="onSubmit(data.item, true)" class='table-confirm-button btn-text px-2 py-1 mx-1'>承認</b-button>
                    <b-button pill @click="onSubmit(data.item, false)" class='table-check-button btn-text px-2 py-1 mx-1'>非承認</b-button>
                  </div>
                </template>
                <template #cell(date)=''>
                  <div class="mt-3">
                    <p> ー </p>
                  </div>
                </template>
                <template #cell(chat)=''>
                  <div class="mt-3">
                    <p> ー </p>
                  </div>
                </template>
                <template #cell(memo)='data'>
                  <div style="width: 3rem" class="text-center" @click="showModal(data.item)">
                    <b-icon icon="pencil-square" font-scale="1.5" class='mr-2 icon-button'></b-icon>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>

        </b-col>
      </b-row>
    </b-container>

    <b-modal
      centered
      v-model="memoModal"
      title="メモを編集"
      @ok="submitMemo"
      okTitle="保存"
      cancelTitle="キャンセル"
    >
      <p>メモを残すことができます</p>
      <b-form-textarea
        v-model="memo"
        required
        rows="5"
        max-rows="6"
      ></b-form-textarea>
    </b-modal>

  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import AgencyList from "@/components/Agency/AgencyList"


export default {
  components: { AgencyList },
  data() {
    return{
      idToken: localStorage.idToken,
      recruitList: [],
      userInfo: {},
      jobInfo: {},
      selected: null,
      memo: "",
      searchWord: "",
      isAgency: false,
      memoModal: false,
      emStatusOptions: [
        { value: 'full', text: this.$i18n.t('message.full_time_employee') },
        { value: 'part', text: this.$i18n.t('message.part_time_job') },
        { value: 'temporary', text: this.$i18n.t('message.temporary_staff') },
        { value: 'contract', text: this.$i18n.t('message.contract_employee') },
      ],
      totalNums: 0,
      perPage: 10,
      currentPage: 1,
      fields: [
        { key: 'created_at', label: '応募受付日時' },
        { key: 'job_id', label: '媒体/求人題名' },
        { key: 'user_id', label: '応募者情報' },
        { key: 'state', label: '対応状況' },
        { key: 'date', label: '面接日程' },
        { key: 'chat', label: 'チャット' },
        { key: 'memo', label: 'メモ' },
      ],
      currentRecruit: {},
      publicOptions: {
        'public': this.$i18n.t('message.public'),
        'private': this.$i18n.t('message.private')
      },
    }
  },
  mounted(){
    this.fetchRecruits()
    this.checkAgency()
  },
  methods: {
    tableDateFormat(date){
      moment.locale("ja");
      return moment(date).format('YYYY/MM/DD (ddd)');
    },
    onChangeSearch() {
     this.$store.commit('setLoading', true)
     this.fetchRecruits(this.searchWord)
    },
    onSubmit(r, result) {
      var t = ""
      var d = ""
      if(result) {
        t = "承認しますか？"
        d = "承認をすると、マッチングが成立し、選考を進めれます"
      } else {
        t = "非承認しますか？"
        d = "非承認をすると、マッチングが不成立となります"
      }

      this.$swal.fire({
        title: t,
        text: d,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '決定'
      }).then((res) => {
        if(res.isConfirmed) {
          axios
            .patch(process.env.VUE_APP_API + "/api/org/recruits/" + r.r_id, {is_approve: result}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
            .then(res => {
              this.fetchRecruits("offer")
              console.log(res)
              if(result) {
                if(this.isAgency) {
                  this.$router.push("/agency/mail-box?u_id=" + r.user_id)
                }else {
                  this.$router.push("/organization/mail-box?u_id=" + r.user_id)
                }
              }
            }).catch(error => {
              console.log('this is org error', error)
            })
        }
      })
    },
    showModal(u) {
      this.currentRecruit = u
      this.memoModal = true
      this.memo = u.memo
    },
    submitMemo() {
      axios
        .patch(process.env.VUE_APP_API + "/api/org/recruit/" + this.currentRecruit.r_id, {recruit: {memo: this.memo}}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {this.fetchRecruits("offer")})
    },
    fetchRecruits(w="") {
      axios
        .get(process.env.VUE_APP_API + "/api/org/recruits?word=" + w + "&state=offer", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.recruitList = response.data.data
          this.totalNums = this.recruitList.length
          this.$store.commit('setLoading', false)
        }).catch(error => {
          this.recruitList = []
          this.totalNums = 0
          this.$store.commit('setLoading', false)
          console.log('this is org error', error)
        })
    },
    tableTimeFormat(date){
      moment.locale("ja");
      return moment(date).format('HH:mm');
    },
    formatUser(user_id){
      console.log(user_id)
      return '00歳/男性/東京都千代田区';
    },
    checkAgency() {
      var idToken = localStorage.idToken
      axios.get(process.env.VUE_APP_API + "/api/agcy/agency/1", {headers: {'Authorization': 'Bearer ' + idToken}})
        .then(() => { this.isAgency = true})
    },
    onUpdateAll() {
      this.$store.commit('setLoading', true)
      this.fetchRecruits()
    }

  },
}

</script>
<style scoped lang="scss">
.new{
  font-size: 1rem;
  font-weight: bold;
}
.btn-text {
  font-size: 1rem;
}
</style>
